import { render, staticRenderFns } from "./VaultOfDarkness.vue?vue&type=template&id=c028034a"
import script from "./VaultOfDarkness.vue?vue&type=script&lang=js"
export * from "./VaultOfDarkness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports